import { Col, Offcanvas, Card, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../../utility/WebService";
import HelperService from "../../../utility/HelperService";

interface PropData {
    isShow: boolean;
    isClose: () => void;
    project_uuid: string;
    is_session: boolean;
}

interface ProjectDetails {
    project_name: string;
    address: string;
    unit_count: number;
    status: string;
    total_canceled_bookings: number;
    total_bookings: number;
    total_received_amount: number;
    total_expense: number;
    total_registry_completed_area: number;
    available_area: number;
    available_units: number;
    total_sold_area: number;
    total_area: number;
    land_purchase_price: number;
    land_area: number;
    current_market_value: number;
    total_sales_amount: number;
    total_due: number;
    total_vendor_payment: number;
    stockUsed: any[]
}

const ProjectDasboard = (props: PropData) => {
    const [projectDetails, setProjectDetails] = useState<ProjectDetails | null>(null);
    const getValue = (value: string | number | null | undefined) => value || value === 0 ? value : "N/A";
    const getFormattedNumber = (value: number) => value || value === 0 ? HelperService.getCurrencyFormatter(value) : "N/A";
    const redStats = projectDetails ? [
        { label: "Land Purchase Price", value: getFormattedNumber(projectDetails.land_purchase_price) + " ₹" },
        { label: "Current Market Value", value: getFormattedNumber(projectDetails.current_market_value) + " ₹" },
        { label: "Land Area", value: getFormattedNumber(projectDetails.land_area) + " Acres" },
    ] : [];
    const projectStats = projectDetails ? [
        { label: "Unit Count", value: getValue(projectDetails.unit_count) },
        { label: "Available Plots", value: getValue(projectDetails.available_units) },
        { label: "Total Bookings", value: getValue(projectDetails.total_bookings) },
        { label: "Canceled Bookings", value: getValue(projectDetails.total_canceled_bookings) },
        { label: "Total Saleable Area", value: getFormattedNumber(projectDetails.total_area) + " sq.ft" },
        { label: "Total Sold Area", value: getFormattedNumber(projectDetails.total_sold_area) + " sq.ft" },
        { label: "Registry Done Area", value: getFormattedNumber(projectDetails.total_registry_completed_area) + " sq.ft" },
        { label: "Available Area", value: getFormattedNumber(projectDetails.available_area) + " sq.ft" },
    ] : [];
    const amountStats = projectDetails ? [
        { label: "Total Sales Amount", value: getFormattedNumber(projectDetails.total_sales_amount) + " ₹" },
        { label: "Received Amount", value: getFormattedNumber(projectDetails.total_received_amount) + " ₹" },
        { label: "Total Due", value: getFormattedNumber(projectDetails.total_due) + " ₹" },
        { label: "Total Expenses", value: getFormattedNumber(projectDetails.total_expense) + " ₹" },
        { label: "Total Supplier Payment", value: getFormattedNumber(projectDetails.total_vendor_payment) + " ₹" },
    ] : [];
    const stockStats = projectDetails && projectDetails?.stockUsed && projectDetails.stockUsed.length ?
        projectDetails.stockUsed.map((item: any) => ({ label: item.stock?.name, value: getFormattedNumber(item.total_used) + " " + item.stock?.unit?.name })) : [];

    useEffect(() => {
        if (props.isShow && props.project_uuid) {
            setProjectDetails(null);
            getProjectList();
        }
    }, [props.isShow, props.project_uuid, props.is_session]);

    const getProjectList = () => {
        WebService.getAPI({
            action: `project-count-detail/${props.project_uuid}`,
            is_session: props.is_session,
        }).then((res: any) => {
            setProjectDetails(res);
        }).catch((err) => {
            console.log("err", err);
        });
    };





    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>Project Dashboard</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    {projectDetails ? (
                        <>
                            <Card className="mb-3">
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-start gap-3">
                                        <div>
                                            <div className="font-18 fw-bold">{getValue(projectDetails.project_name)}</div>
                                            <div className="font-13 text-muted mt-1">{getValue(projectDetails.address)}</div>
                                        </div>
                                        <span className="badge bg-success-subtle text-success">{getValue(projectDetails.status)}</span>
                                    </div>
                                </Card.Body>
                            </Card>

                            <Row className="g-2">
                                {props.is_session && redStats.map((item, i) => (
                                    <Col md={6} key={item.label}>
                                        <Card className="h-100">
                                            <Card.Body>
                                                <div className="font-12 text-muted">{item.label}</div>
                                                <div className="font-18 fw-bold text-black mt-1">{item.value}</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                                {projectStats.map((item, i) => (
                                    <Col md={6} key={item.label}>
                                        <Card className="h-100">
                                            <Card.Body>
                                                <div className="font-12 text-muted">{item.label}</div>
                                                <div className="font-18 fw-bold text-black mt-1">{item.value}</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                                {props.is_session && amountStats.map((item, i) => (
                                    <Col md={6} key={item.label}>
                                        <Card className="h-100">
                                            <Card.Body>
                                                <div className="font-12 text-muted">{item.label}</div>
                                                <div className="font-18 fw-bold text-black mt-1">{item.value}</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                                {stockStats.map((item, i) => (
                                    <Col md={6} key={item.label}>
                                        <Card className="h-100">
                                            <Card.Body>
                                                <div className="font-12 text-muted">{item.label}</div>
                                                <div className="font-18 fw-bold text-black mt-1">{item.value}</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}

                            </Row>
                        </>
                    ) : (
                        <div className="text-center text-muted py-4">Loading project details...</div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ProjectDasboard;
